<div class="button-toolbar">

  <div class="btn-group" role="group" >
    <span class="d-inline-block" data-bs-toggle="tooltip" title="Reset">
      <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        Reset
      </button>

      <ul class="dropdown-menu">
        <li>
          <span class="d-inline-block full-width" data-bs-toggle="tooltip"
            title="Reload the application from the server">
            <a class="dropdown-item" (click)="onButtonAction('resetApplication','')">Application</a>
          </span>
        </li>
        <li>
          <span class="d-inline-block full-width" data-bs-toggle="tooltip" title="Reset the section currently selected">
            <a class="dropdown-item" (click)="onButtonAction('resetSection','')">Section</a>
          </span>
        </li>

      </ul>
    </span>
  </div>


  <div class="btn-group" role="group" aria-label="Validate Actions">
    <button type="button" class="btn btn-light" aria-label="Validate Business Rules" 
      [ngClass]="{'btn-group-near': fieldsErrorsControl.isValidateButtonPressed() && fieldsErrorsControl.existsErrors()}"      
      title="Validate Business Rules" (click)="onButtonAction('validate','')">Validate</button>
    <button type="button" *ngIf="fieldsErrorsControl.isValidateButtonPressed() && fieldsErrorsControl.existsErrors()"
      class="btn btn-light btn-group-near" aria-label="Go to Previous Error" title="Go to Previous Error"
      (click)="onButtonAction('previousError','')">&ShortUpArrow;</button>
    <button type="button" *ngIf="fieldsErrorsControl.isValidateButtonPressed() && fieldsErrorsControl.existsErrors()"
      class="btn btn-light" aria-label="Go to Next Error" title="Go to Next Error"
      (click)="onButtonAction('nextError','')">&ShortDownArrow;</button>
  </div>

  <button *ngIf="authService.hasAnyRole('EVH_CREATE_AND_SEND_PRODUCT_SUBMISSION') && !(sendMessageLoading$ | async)"
          type="button" 
          class="btn btn-light"
          aria-label="Send Current Message" 
          title="Send Current Message" 
          (click)="onButtonAction('send','')">Send</button>
 
  <div class="btn-group" role="group">
    <span class="d-inline-block" data-bs-toggle="tooltip" title="Export Message">
      <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        Export
      </button>

      <ul class="dropdown-menu">
        <li>
          <span class="d-inline-block full-width" data-bs-toggle="tooltip" title="Export Message as XML">
            <a class="dropdown-item" (click)="onButtonAction('export','xml')">XML</a>
          </span>
        </li>
        <li>
          <span class="d-inline-block full-width" data-bs-toggle="tooltip"
            title="Export Message as ZIP (with Attachments if present)">
            <a class="dropdown-item" (click)="onButtonAction('export','zip')">ZIP</a>
          </span>
        </li>
        <li>
          <span class="d-inline-block full-width" data-bs-toggle="tooltip"
            title="Export Message as RTF Document (Rich Text Format)">
            <a class="dropdown-item" (click)="onButtonAction('export','rtf')">RTF</a>
          </span>
        </li>
      </ul>
    </span>
  </div>

  <button *ngIf="showDuplicateButton()" type="button" class="btn btn-light"
    aria-label="Duplicate the Element selected in the Tree View" title="Duplicate the Element selected in the Tree View"
    (click)="onButtonAction('duplicate','')">Duplicate</button>

  <button *ngIf="(!isListViewNode()) && (!isTreeNodeXEVPRM_MESSAGE())" type="button" class="btn btn-light"
    aria-label="Remove the Element selected in the Tree View" title="Remove the Element selected in the Tree View"
    (click)="onButtonAction('remove',selectedNode)">Remove</button>

  <button *ngIf="isListViewNode()" type="button" class="btn btn-light"
    aria-label="Remove all selected elements in the list" title="Remove selected item(s) from the Tree View Area"
    (click)="onButtonAction('removeall', selectedNode)">Remove</button>

  <button *ngIf="isListViewNode() && isSelectAllVisible()" class="square-button btn btn-light" aria-label="Select All" title="Select All"
    (click)="onButtonAction('selectAll',selectedNode)">
    &#x2611;
  </button>
    
  <button *ngIf="isListViewNode() && isSelectAllVisible()" class="square-button btn btn-light" aria-label="Deselect All"
           title="Deselect All" (click)="onButtonAction('deselectAll',selectedNode)">
           &#x2610;
  </button>

</div>
